import { Injectable } from '@angular/core';
import { CertRequirementCatalogOverrideGroup, RequestByIdOrExternalId } from '@ats/api/cm';
import { gql, Query } from 'apollo-angular';

export type OverrideGroupList = Pick<CertRequirementCatalogOverrideGroup, 'id' | 'name'>;

type OverrideGroupListResponse = {
	certRequirementCatalogDetail: {
        id: number;
		overrideGroupList: OverrideGroupList[];
	};
};

@Injectable()
export class OverrideGroupGqlService extends Query<
    OverrideGroupListResponse,
	{ request: RequestByIdOrExternalId }
> {
	readonly document = gql`
		query getOverrideGroup($request: RequestByIdOrExternalId!) {
		certRequirementCatalogDetail(request: $request) {
            id
			overrideGroupList {
				id
				name
			}
		}
	}
	`;
}
